import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { useTranslations } from "use-intl";
export const CountDown = t0 => {
  const $ = _c(15);
  const {
    endTime,
    onEnded
  } = t0;
  const t = useTranslations("wallet.CountDown");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = Date.now();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [startTime, setStartTime] = useState(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setStartTime(Date.now());
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== endTime) {
    t3 = [endTime];
    $[2] = endTime;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  useEffect(t2, t3);
  const timeTillExpirationMs = endTime - Date.now();
  const t4 = Math.max(Math.floor(timeTillExpirationMs / 1000 / 60), 0);
  const t5 = Math.max(Math.floor(timeTillExpirationMs / 1000 % 60), 0);
  let t6;
  if ($[4] !== t4 || $[5] !== t5) {
    t6 = {
      minutes: t4,
      seconds: t5
    };
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const [timeRemaining, setTimeRemaining] = useState(t6);
  let t7;
  if ($[7] !== endTime || $[8] !== onEnded) {
    t7 = () => {
      const interval = setInterval(() => {
        const timeTillExpirationMs_0 = endTime - Date.now();
        setTimeRemaining({
          minutes: Math.max(Math.floor(timeTillExpirationMs_0 / 1000 / 60), 0),
          seconds: Math.max(Math.floor(timeTillExpirationMs_0 / 1000 % 60), 0)
        });
        if (timeTillExpirationMs_0 <= 0) {
          onEnded?.();
        }
      }, 1000);
      return () => clearInterval(interval);
    };
    $[7] = endTime;
    $[8] = onEnded;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== endTime) {
    t8 = [endTime];
    $[10] = endTime;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  useEffect(t7, t8);
  const moreThanHalfRemaining = timeTillExpirationMs > (endTime - startTime) / 2;
  if (timeRemaining.minutes > 0 && moreThanHalfRemaining) {
    const t9 = timeRemaining.minutes + (timeRemaining.seconds >= 30 ? 1 : 0);
    let t10;
    if ($[12] !== t || $[13] !== t9) {
      t10 = t("minutes", {
        count: t9
      });
      $[12] = t;
      $[13] = t9;
      $[14] = t10;
    } else {
      t10 = $[14];
    }
    return t10;
  }
  return `${timeRemaining.minutes}:${timeRemaining.seconds.toString().padStart(2, "0")}`;
};